import { Grid, IconButton, Tooltip } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import EditIcon from '@mui/icons-material/Edit';
import { LegalProceedingsListActionsProps } from './props';
import { LEGAL_PROCEEDINGS_EDIT } from '../../../../../../routes/paths';
import { MouseEventHandler } from 'react';

export const LegalProceedingsListActions = ({
    id,
}: LegalProceedingsListActionsProps) => {
    const navigate = useNavigate();
    const handleEdit: MouseEventHandler<HTMLButtonElement> | undefined = (
        e
    ) => {
        e.stopPropagation();
        navigate(`${LEGAL_PROCEEDINGS_EDIT}/${id}`);
    };

    return (
        <Grid textAlign="left" width="100%">
            <Tooltip title="Editar">
                <IconButton size="small" onClick={handleEdit}>
                    <EditIcon type="submit" sx={{ color: 'primary.main' }} />
                </IconButton>
            </Tooltip>
        </Grid>
    );
};
